import React from 'react';
import ReactDOM from 'react-dom';

import BlockerTitle from './BlockerTitle';
import BlockerMiddleImage from './BlockerMiddleImage';
import BlockerSubtitle from './BlockerSubtitle';
import BlockerLinkButton from './BlockerLinkButton';
import BlockerCallbackButton from './BlockerCallbackButton';

export default class Blocker {
  constructor({element, title, middleImage, subtitle, buttons = []} = {}) {
    let middleImageClass, middleImageHtml;
    if(middleImage && typeof middleImage === 'object') {
      middleImageClass = middleImage.class
      middleImageHtml = middleImage.html;
    }
    Object.assign(this, {
      element, title, middleImageClass, middleImageHtml, subtitle, buttons
    });
  }

  show() {
    let universalBlocker = this.element.querySelector('.universal-blocker');
    if(universalBlocker) {
      universalBlocker.classList.remove('hide');
    } else {
      this.render();
    }
  }

  hide() {
    let universalBlocker = this.element.querySelector('.universal-blocker');
    if(universalBlocker) {
      universalBlocker.classList.add('hide');
    }
  }

  render() {
    ReactDOM.render( 
      <div className="universal-blocker">
        <BlockerTitle title={this.title} />
        <BlockerMiddleImage
          middleImageClass={this.middleImageClass}
          middleImageHtml={this.middleImageHtml} />
        <BlockerSubtitle subtitle={this.subtitle} />
        <div className="buttons">
          {this.buttons.map((button, index) => {
            if(button.link) {
              return <BlockerLinkButton {...button} key={index} />
            } else if(button.callback) {
              return <BlockerCallbackButton {...button} key={index} />
            }
          })}
        </div>
      </div>,
      this.element
    )
  }
};
